import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const ArrowDownIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 18 18"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.085 12.924c-.029.006-.056.014-.085.014-.03 0-.056-.008-.085-.014-.028-.005-.056-.01-.083-.02-.028-.013-.052-.032-.078-.05-.019-.013-.04-.02-.058-.036-.005-.005-.007-.012-.013-.018-.005-.006-.011-.008-.017-.014L2.65 5.854a.489.489 0 0 1 .03-.668.436.436 0 0 1 .637.031L9 11.765l5.684-6.548a.436.436 0 0 1 .637-.03c.098.092.148.22.148.348a.482.482 0 0 1-.118.319l-6.017 6.932c-.006.007-.012.008-.018.015-.005.005-.007.012-.012.017-.018.016-.039.023-.058.036-.026.018-.05.037-.078.05-.027.01-.054.015-.083.02"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default ArrowDownIcon;
